// src/pages/CompanyInfo.jsx
import React, { useState, useEffect } from 'react';
import { getData, putData } from '../helpers/ApiSettings';
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Youtube,
  MessageCircleMore
} from 'lucide-react';

const SOCIAL_MEDIA_OPTIONS = [
  { value: 'facebook', label: 'Facebook', icon: Facebook },
  { value: 'instagram', label: 'Instagram', icon: Instagram },
  { value: 'linkedin', label: 'LinkedIn', icon: Linkedin },
  { value: 'twitter', label: 'Twitter', icon: Twitter },
  { value: 'youtube', label: 'YouTube', icon: Youtube },
  { value: 'whatsapp', label: 'Whatsapp', icon: MessageCircleMore }
];

const CompanyInfo = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    postalCode: '',
    city: '',
    country: '',
    vatNumber: '',
    siretNumber: '',
    socialmedia: [],
    opening_hours: '',
    // additionalInfo: ''
  });

  const fetchCompanyInfo = async () => {
    try {
      setLoading(true);
      const response = await getData('/company-info?populate=*');
      setFormData(response.data.data);
      // console.log(response.data.data)
      setError(null);
    } catch (err) {
      setError('Erreur lors du chargement des informations');
      console.error('Error fetching company info:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyInfo();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        opening_hours: formData.opening_hours,
        address: formData.address,
        postalCode: formData.postalCode,
        city: formData.city,
        country: formData.country,
        vatNumber: formData.vatNumber,
        siretNumber: formData.siretNumber,
        //   additionalInfo: formData.additionalInfo,
        socialmedia: formData.socialmedia.map(social => ({
          name: social.name,
          url: social.url
        }))
      };
      await putData('/company-info', { data: dataToSend });
      //   if (formData.id) {
      //     await putData(`/company-info`, { data: formData });
      //   } else {
      //     await putData('/company-info', { data: formData });
      //   }
      alert('Informations mises à jour avec succès');
    } catch (err) {
      alert('Erreur lors de la mise à jour des informations');
      console.error('Error saving company info:', err);
    }
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="h4 mb-0">Informations de l'entreprise</h2>
        <button
          onClick={fetchCompanyInfo}
          className="btn btn-outline-primary"
        >
          Actualiser
        </button>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {/* Basic Information */}
            <div className="row mb-4">
              <h5 className="mb-3">Informations de base</h5>
              <div className="col-md-6 mb-3">
                <label htmlFor="name" className="form-label">Nom de l'entreprise</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="phone" className="form-label">Téléphone</label>
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Hours */}
            <div className="row mb-4">
              <h5 className="mb-3">Horaires</h5>
              <div className="col-12">
                <label htmlFor="opening_hours" className="form-label">Horaires d'ouverture</label>
                <textarea
                  className="form-control"
                  id="opening_hours"
                  name="opening_hours"
                  value={formData.opening_hours}
                  onChange={handleInputChange}
                  rows="4"
                ></textarea>
              </div>
            </div>

            {/* Address */}
            {/* <div className="row mb-4">
              <h5 className="mb-3">Adresse</h5>
              <div className="col-12 mb-3">
                <label htmlFor="address" className="form-label">Adresse</label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="postalCode" className="form-label">Code postal</label>
                <input
                  type="text"
                  className="form-control"
                  id="postalCode"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="city" className="form-label">Ville</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="country" className="form-label">Pays</label>
                <input
                  type="text"
                  className="form-control"
                  id="country"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                />
              </div>
            </div> */}

            {/* Legal Information */}
            {/* <div className="row mb-4">
              <h5 className="mb-3">Informations légales</h5>
              <div className="col-md-6 mb-3">
                <label htmlFor="vatNumber" className="form-label">Numéro de TVA</label>
                <input
                  type="text"
                  className="form-control"
                  id="vatNumber"
                  name="vatNumber"
                  value={formData.vatNumber}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="siretNumber" className="form-label">Numéro SIRET</label>
                <input
                  type="text"
                  className="form-control"
                  id="siretNumber"
                  name="siretNumber"
                  value={formData.siretNumber}
                  onChange={handleInputChange}
                />
              </div>
            </div> */}

            {/* Social Media */}
            <div className="row mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Réseaux sociaux</h5>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => {
                    setFormData(prev => ({
                      ...prev,
                      socialmedia: [...prev.socialmedia, { name: '', url: '' }]
                    }));
                  }}
                >
                  Ajouter un réseau social
                </button>
              </div>

              {formData.socialmedia.map((social, index) => (
                <div key={social.id || index} className="col-12 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5 mb-3">
                          <label className="form-label">Nom du réseau social</label>
                          <select
                            className="form-select"
                            value={social.name}
                            onChange={(e) => {
                              const newSocialMedia = [...formData.socialmedia];
                              newSocialMedia[index] = {
                                ...newSocialMedia[index],
                                name: e.target.value
                              };
                              setFormData(prev => ({
                                ...prev,
                                socialmedia: newSocialMedia
                              }));
                            }}
                          >
                            <option value="">Sélectionnez un réseau social</option>
                            {SOCIAL_MEDIA_OPTIONS.map((option) => {
                              const Icon = option.icon;
                              return (
                                <option
                                  key={option.value}
                                  value={option.value}
                                  className="flex items-center gap-2"
                                >
                                  <Icon className="inline-block w-4 h-4 mr-2" />
                                  {option.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="col-md-5 mb-3">
                          <label className="form-label">URL</label>
                          <div className="flex items-center">
                            <input
                              type="url"
                              className="form-control"
                              value={social.url}
                              onChange={(e) => {
                                const newSocialMedia = [...formData.socialmedia];
                                newSocialMedia[index] = {
                                  ...newSocialMedia[index],
                                  url: e.target.value
                                };
                                setFormData(prev => ({
                                  ...prev,
                                  socialmedia: newSocialMedia
                                }));
                              }}
                              placeholder="https://..."
                            />
                          </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-end mb-3">
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => {
                              const newSocialMedia = formData.socialmedia.filter((_, i) => i !== index);
                              setFormData(prev => ({
                                ...prev,
                                socialmedia: newSocialMedia
                              }));
                            }}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Additional Information */}
            {/* <div className="row mb-4">
              <h5 className="mb-3">Informations supplémentaires</h5>
              <div className="col-12">
                <label htmlFor="additionalInfo" className="form-label">Notes additionnelles</label>
                <textarea
                  className="form-control"
                  id="additionalInfo"
                  name="additionalInfo"
                  value={formData.additionalInfo}
                  onChange={handleInputChange}
                  rows="4"
                ></textarea>
              </div>
            </div> */}

            <div className="d-flex justify-content-end">
              <button type="submit" className="btn btn-primary">
                Enregistrer les modifications
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;